import { alto, apple, bondiBlue, emperor, hotCinnamon, mercury, mineShaft, thunderBird, white } from '../Colors/Colors';
import { CONTEXT } from './constants';
export const getTheme = (context, theme, titled) => {
  var _theme$fontColors, _theme$fontColors$bod, _theme$whiteSpace;

  switch (context) {
    case CONTEXT.important:
      if (titled) {
        return {
          titleBackground: emperor,
          titleText: white,
          messageBackground: white,
          messageText: emperor,
          border: alto
        };
      } else {
        return {
          messageBackground: emperor,
          messageText: white,
          border: emperor
        };
      }

    case CONTEXT.info:
      if (titled) {
        return {
          titleBackground: bondiBlue,
          titleText: white,
          messageBackground: white,
          messageText: mineShaft,
          border: alto
        };
      } else {
        return {
          messageBackground: bondiBlue,
          messageText: white,
          border: bondiBlue
        };
      }

    case CONTEXT.light:
      if (titled) {
        return {
          titleBackground: mercury,
          titleText: mineShaft,
          messageBackground: white,
          messageText: mineShaft,
          border: alto
        };
      } else {
        return {
          messageBackground: white,
          messageText: mineShaft,
          border: alto
        };
      }

    case CONTEXT.invalid:
      if (titled) {
        return {
          titleBackground: thunderBird,
          titleText: white,
          messageBackground: white,
          messageText: mineShaft,
          border: alto
        };
      } else {
        return {
          messageBackground: thunderBird,
          messageText: white,
          border: thunderBird
        };
      }

    case CONTEXT.warning:
      if (titled) {
        return {
          titleBackground: hotCinnamon,
          titleText: white,
          messageBackground: white,
          messageText: mineShaft,
          border: alto
        };
      } else {
        return {
          messageBackground: hotCinnamon,
          messageText: white,
          border: hotCinnamon
        };
      }

    case CONTEXT.valid:
      if (titled) {
        return {
          titleBackground: apple,
          titleText: white,
          messageBackground: white,
          messageText: mineShaft,
          border: alto
        };
      } else {
        return {
          messageBackground: apple,
          messageText: white,
          border: apple
        };
      }

    default:
      return {
        titleBackground: thunderBird,
        titleText: (theme === null || theme === void 0 ? void 0 : (_theme$fontColors = theme.fontColors) === null || _theme$fontColors === void 0 ? void 0 : (_theme$fontColors$bod = _theme$fontColors.body) === null || _theme$fontColors$bod === void 0 ? void 0 : _theme$fontColors$bod.base) || white,
        messageBackground: (theme === null || theme === void 0 ? void 0 : (_theme$whiteSpace = theme.whiteSpace) === null || _theme$whiteSpace === void 0 ? void 0 : _theme$whiteSpace.base) || white,
        messageText: thunderBird,
        border: thunderBird
      };
  }
};